import { render, staticRenderFns } from "./OnboardingVerificationInternal.vue?vue&type=template&id=2b1618cc&"
import script from "./OnboardingVerificationInternal.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports